import React, { useState } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { TextInput } from '../../../Helpers/Inputs';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { object, string } from 'yup';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';
import GetProductTypeEnum from '../../../../types/productType';
import { InputMaskPhone } from '../../../Helpers/Formatters';
import { numbersOnlyString, heightFromString } from '../../../Helpers/Conversion';
import { PropTypes } from 'prop-types';
import CovrButton from '../../../Helpers/Buttons/CovrButton';
import '../Haven.scss';

export default function BestowApplyDialog(props) {
  const { register, errors, handleSubmit } = useForm({
    validationSchema: BestowApplyDialog.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(props.quoteFields.email || '');
  const [phone, setPhone] = useState(props.quoteFields.phone || '');
  const [firstName, setFirstname] = useState('');
  const [lastName, setLastname] = useState('');

  const onSubmit = () => {

    setLoading(true);

    const BESTOW_TYPE_ID = 63;
  
    props.logQuote(email, phone, props.selectedQuote, BESTOW_TYPE_ID, props.selectedQuote.quoteID).then(() => {
      window.location = BestowHandoffUrl(props.quoteFields, props.selectedQuote);
    });
  }

  return (
    <div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <p className="disclaimer-agreement-text">Apply</p>
        <Row className="justify-content-center">
          <Col>
            <Row>
              <Col>
                <div className="form-area">
                  <Form.Group>
                    <TextInput
                      name="firstName"
                      id="firstName"
                      value={firstName}
                      onChange={(e) => setFirstname(e.target.value)}
                      label="First Name"
                      inputRef={register}
                      errors={errors.firstName}
                    />
                  </Form.Group>
                  <Form.Group>
                    <TextInput
                      name="lastName"
                      id="lastName"
                      value={lastName}
                      onChange={(e) => setLastname(e.target.value)}
                      label="Last Name"
                      inputRef={register}
                      errors={errors.lastName}
                    />
                  </Form.Group>
                  <Form.Group>
                    <TextInput
                      name="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      label="Email (Required)"
                      inputRef={register}
                      errors={errors.email}
                    />
                  </Form.Group>
                  <Form.Group>
                    <TextInput
                      name="phone"
                      id="phone"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      label="Phone (Required)"
                      inputRef={register}
                      errors={errors && errors.phone}
                      InputProps={{
                        inputComponent: InputMaskPhone,
                      }}
                    />
                  </Form.Group>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Form.Group>
                <CovrButton
                  name="CONTINUE TO BESTOW"
                  loading={loading}
                />
              </Form.Group>
            </Row>
            <Row className="disclaimer-content">
              <p>By clicking Continue, you are providing your signed permission for Covr Financial Technologies to contact you at the email and telephone number provided, including via text message and live, automated and pre-recorded telephone calls, even if your number is on a Do Not Call list. You also acknowledge that you have received and agree to our Privacy Policy, Terms of Use, and Consent to Do Business Electronically. You may revoke these consents at any time by emailing us at <a href="mailto:support@covrtech.com">support@covrtech.com</a>.</p>
            </Row>
          </Col>
        </Row>

      </Form>
    </div>
  );
}

export function BestowHandoffUrl(quoteParams, selectedQuote) {

  var accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  const gender = quoteParams.gender === 'M' ? 'male' : 'female';
  const tobacco = quoteParams.tobacco === 'yes';
  const height = heightFromString(quoteParams.height);
  const weight = numbersOnlyString(quoteParams.weight);
  const accountName = accountObj.account.accountName;
  const queryParams = new URLSearchParams({
      date_of_birth: quoteParams.birthdate,
      gender: gender,
      height: height.heightTotalIn,
      weight: weight,
      state: quoteParams.state || quoteParams.stateOfResidence,
      tobacco: tobacco,
      product: selectedQuote.subProductID,
      coverage: quoteParams.coverageAmount,
      utm_source: accountName,
      utm_medium: 'agents',
      quoteid: selectedQuote.quoteID,
  });

  return `https://enroll.bestow.com/get-started/?${queryParams.toString()}`;
}

BestowApplyDialog.propTypes = {
  logQuote: PropTypes.func.isRequired,
  selectedQuote: PropTypes.object.isRequired,
};

BestowApplyDialog.ValidationSchema = object().shape({
  email: string()
    .email('Email address must be valid.')
    .required('Email is required'),
  phone: string().required('Phone is required.').matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, 'Phone must be formatted as (123) 456-7890'),
  firstName: string()
    .matches(/^\s*$|^[ a-zA-ZÀ-ÖØ-öø-ÿ'.-]+$/, 'Numbers not allowed.')
    .required('First Name is required.'),
  lastName: string()
    .matches(/^\s*$|^[ a-zA-ZÀ-ÖØ-öø-ÿ'.-]+$/, 'Numbers not allowed.')
    .required('Last Name is required.'),
});



// WEBPACK FOOTER //
// ./src/components/Quoters/Digital/Bestow/BestowApplyDialog.js